import _styled from '@emotion/styled/base';
import { Spacer } from '../../primitives/Spacer/index.js';

const COLUMN_WIDTHS = {
  equal: '1fr 1fr',
  minMax: 'min-content 1fr',
  maxMin: '1fr min-content'
};
const CardMediaGrid = _styled("div", {
  target: "e1pohl2f1"
})("display:grid;grid-template-columns:", ({
  columnWidths,
  hasTwoColumns
}) => hasTwoColumns ? COLUMN_WIDTHS[columnWidths] : '1fr', ";");
const StyledFooter = _styled(Spacer, {
  target: "e1pohl2f0"
})(({
  theme,
  footerVariant
}) => footerVariant === 'filled' && `
      background-color: ${theme.colorScheme.status.default.background.neutral};
    `, ";");

export { COLUMN_WIDTHS, CardMediaGrid, StyledFooter };
